import {
  Button
} from "./chunk-QXEA2YZ6.js";
import {
  Icon
} from "./chunk-7IEFGXFA.js";

// src/PanelCloseButton.tsx
import { jsx } from "react/jsx-runtime";
function PanelCloseButton({ title, onClose }) {
  return /* @__PURE__ */ jsx(Button, { type: "button", variant: "ghost", size: "icon-xs", "data-panel-close": true, "aria-label": `Close ${title}`, title: `Close ${title}`, onClick: onClose, className: "h-6 w-6 shrink-0 rounded-[6px] p-1 text-muted-foreground hover:text-foreground", children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "h-4 w-4" }) });
}

export {
  PanelCloseButton
};
//# sourceMappingURL=chunk-W22Y52AU.js.map